import { Autocomplete, Box, Checkbox, TextField, Typography } from '@mui/material';
import PermissionsStyles from '../../../../components/Permissions/styles/PermissionsStyles';
import { AgentEmail } from './AgentManagerChips';
import { agentLabel } from './agentManagerUtils';

// Where each selected agent's approve/reject email will go.
const SelectedAgentEmails = ({ agents }) => {
  const withEmail = agents.filter((a) => a.email);
  if (!withEmail.length) return null;
  return (
    <Box mt={0.5}>
      <Typography variant="caption" color="text.secondary">
        מייל לעדכון הסוכן בסיום:
      </Typography>
      {withEmail.map((a) => (
        <Box key={a.agentCode}>
          <Typography variant="caption" color="text.secondary">
            {a.agentName}:{' '}
          </Typography>
          <AgentEmail email={a.email} />
        </Box>
      ))}
    </Box>
  );
};

// Adding: several agents at once. Editing: the row's single agent, locked.
const AgentsPicker = ({ options, loading, value, onChange, locked }) => (
  <>
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      loading={loading}
      value={value}
      onChange={(_, selected) => onChange(selected)}
      disabled={locked}
      getOptionLabel={agentLabel}
      isOptionEqualToValue={(option, selected) => option.agentCode === selected.agentCode}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.agentCode}>
          {!locked && <Checkbox size="small" checked={selected} sx={PermissionsStyles.checkbox} />}
          <Box display="flex" flexDirection="column">
            <span>{agentLabel(option)}</span>
            <AgentEmail email={option.email} />
          </Box>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={locked ? 'סוכן' : 'סוכנים (אפשר לבחור כמה)'}
          required={value.length === 0}
          sx={PermissionsStyles.textField}
        />
      )}
    />
    <SelectedAgentEmails agents={value} />
  </>
);

export default AgentsPicker;
